import * as actions from './actions';
import { ReleaseNotesState } from './state';

export const releaseNotesStore = {
  namespaced: true,
  state: {
    releaseNotes: {
      isLoading: false,
      data: undefined
    },
    truncated: false
  } as ReleaseNotesState,
  actions
};
